<form [formGroup]="formEditaDatosPersonales">
  <div class="row">
    <div class="col">
      <h5 class="modal-title w-100 text-left" id="myModalLabel">
        Datos de cliente
      </h5>
    </div>
    <div class="col">
      <div class="switch info-switch">
        <label>
          Inactivo
          <input type="checkbox" color="info" checked formControlName="estadoCliente" />
          <span class="lever"></span> Activo
        </label>
      </div>
    </div>
  </div>
  <div class="md-form">
    <input type="hidden" formControlName="esClienteBloqueado" id="esClienteBloqueado1" />
    <input type="hidden" formControlName="datosCliente" id="datosCliente" />
  </div>
  <div class="row">
    <!-- Left -->
    <div class="col">
      <div class="md-form">
        <input value="" type="text" id="rut1" class="form-control" placeholder="99999999-9" required #rut1
          formControlName="rutCliente" formatRut />
        <label for="rut1">RUT <app-required-field></app-required-field></label>
        <div *ngIf="

                    formEditaDatosPersonales.get('rutCliente').invalid &&
                    (formEditaDatosPersonales.get('rutCliente').dirty ||
                    formEditaDatosPersonales.get('rutCliente').touched)
                    ">
          <mdb-error *ngIf="
                        formEditaDatosPersonales.get('rutCliente').errors
                            .ValidaFormatoRut
                        ">
            El RUT es erróneo
          </mdb-error>
        </div>
      </div>




    </div>
    <div class="col">
      <div class="md-form">
        <input value="" type="text" id="nombre1" class="form-control" placeholder="Nombre"
          formControlName="nombreCliente" required #nombre1 />
        <label for="nombre1">Nombre <app-required-field></app-required-field></label>
        <div *ngIf="
                                formEditaDatosPersonales.get('nombreCliente').invalid &&
                                (formEditaDatosPersonales.get('nombreCliente').dirty ||
                                formEditaDatosPersonales.get('nombreCliente').touched)
                                ">
          <mdb-error *ngIf="
                                    formEditaDatosPersonales.get('nombreCliente').errors
                                        .required
                                    ">
            Debe ingresar el nombre
          </mdb-error>
          <mdb-error *ngIf="
                                    formEditaDatosPersonales.get('nombreCliente').errors
                                        .minlength
                                    ">
            El nombre debe tener un mínimo de 5 caracteres
          </mdb-error>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="md-form">
        <div class="md-form">
          <mdb-select label="Canal" [options]="optionsCanal" placeholder="Canal" [filterEnabled]="true"
            formControlName="canal"></mdb-select>
        </div>
        <div *ngIf="
                                formEditaDatosPersonales.get('canal').invalid &&
                                (formEditaDatosPersonales.get('canal').dirty ||
                                formEditaDatosPersonales.get('canal').touched)
                                ">
          <mdb-error *ngIf="
                                    formEditaDatosPersonales.get('canal').errors
                                        .required
                                    ">
            Debe ingresar el canal
          </mdb-error>
        </div>
      </div>
    </div>
    <div class="col">
      <div class="md-form">
        <div class="md-form">
          <mdb-select label="Tipo cliente " [options]="listaTipoClienteFilter" placeholder="Tipo de cliente"
            [filterEnabled]="true" formControlName="tipoCliente"></mdb-select>
        </div>
        <div *ngIf="
                                formEditaDatosPersonales.get('tipoCliente').invalid &&
                                (formEditaDatosPersonales.get('tipoCliente').dirty ||
                                formEditaDatosPersonales.get('tipoCliente').touched)
                                ">
          <mdb-error *ngIf="
                                    formEditaDatosPersonales.get('tipoCliente').errors
                                        .required
                                    ">
            Debe ingresar el tipo de cliente
          </mdb-error>
        </div>
      </div>
    </div>
  </div>
  <ng-container *ngIf="mode === 'EDIT'">
    <h5 class="modal-title w-100 text-left" id="myModalLabel">
      Bloqueos/desbloqueos
    </h5>
    <div class="row">
      <div class="col">
        <button *ngIf="formEditaDatosPersonales.get('esClienteBloqueado').value" type="button" size="sm"
          class="btn btn-sm btn-info waves-light" mdbWavesEffect (click)="showModalBloqueo()">
          Desbloquear
        </button>
        <button *ngIf="!formEditaDatosPersonales.get('esClienteBloqueado').value" type="button" size="sm"
          class="btn btn-sm btn-default waves-light" mdbWavesEffect (click)="showModalBloqueo()">
          Bloquear
        </button>
        <button type="button" size="sm" class="btn btn-sm btn-default waves-light" mdbWavesEffect
          (click)="buscaDatosHistorialBloqueo()">
          Historial
        </button>
      </div>
    </div>





  </ng-container>
</form>